import OnScreen from 'onscreen';

export default {
    init() {
        const os = new OnScreen();
        os.on('enter', '.add_fadeInUp ', (element) => {
            if (element.classList.contains('add_fadeInUp') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInUp');
                element.className += ' fadeInUp  show';
            }
        });
        os.on('enter', '.add_fadeInRight ', (element) => {
            if (element.classList.contains('add_fadeInRight') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInRight');
                element.className += ' fadeInRight  show';
            }
        });

        os.on('enter', '.add_fadeInLeft ', (element) => {
            if (element.classList.contains('add_fadeInLeft') && (!(element.classList.contains('animated__mobile--disable') && ($.screenwidth() < 990)))) {
                element.classList.remove('add_fadeInLeft');
                element.className += ' fadeInLeft  show';
            }
        });
        if ($(window).width() < 990) {
            $('#js-services__box').slick({
                dots: false,
                infinite: true,
                arrows: true,
                slidesToShow: 2,
                slidesToScroll: 2,
                centerMode: true,
                responsive: [
                    {
                        breakpoint: 480,
                        settings: {
                            slidesToShow: 1,
                            slidesToScroll: 1,
                            centerPadding: '50px',
                        },
                    },
                    // You can unslick at a given breakpoint now by adding:
                    // settings: "unslick"
                    // instead of a settings object
                ],
            });
        }

        post_height('.js-services__box__item__text');
        post_height('.js-services__box__item__title');
        post_height('.js-services__box__item__list');
        resize_cloud();
    },
    finalize() {
        const os = new OnScreen();
        // JavaScript to be fired on the home page, after the init JS
        os.on('enter', '.js-lines', (element) => {
            if (element.classList.contains('js-lines-init') && ($.screenwidth() >= 990)) {
                element.classList.remove('js-lines-init');
                element.className += ' js-lines-active';
            }
        });
        os.on('leave', '.js-lines', (element) => {
            if (element.classList.contains('js-lines-active') && ($.screenwidth() >= 990)) {
                element.classList.remove('js-lines-active');
                element.className += ' js-lines-init';
            }
        });
    },
};

function post_height($element) {
    $($element).removeAttr('style');
    setTimeout(function () {
        var maxheight = 0;
        $($element).each(function () {
            if ($(this).height() > maxheight) {
                maxheight = $(this).height();
            }
        });

        $($element).css('min-height', maxheight + 'px');
    }, 200);
}

function resize_cloud() {
    var width = $(window).width();
    var originalw = 1400;
    var originalh = 570;
    var ratio;
    if( width < 990 ){
        var Macy = require('macy');
        Macy({
            container: '.cloud',
            trueOrder: false,
            waitForImages: false,
            margin: 2,
            columns: 3,
            breakAt: {
                480: 2,
            },
        });
    }
    if (width < originalw && width >= 990) {
        ratio = width / originalw;
        var newHeight = Math.round(originalh * ratio) + 'px';
        $('.cloud__outer').css('height', newHeight);
        for (var i = 0; i <= 5; i++) {
            $('.cloud__h' + i).each(function () {
                var newFontSize = Math.round($(this).css('font-size').replace('px', '') * ratio) + 'px';
                var newPadLeft = Math.round($(this).css('padding-left').replace('px', '') * ratio) + 'px';
                var newPadTop = Math.round($(this).css('padding-top').replace('px', '') * ratio) + 'px';
                var newPadRight = Math.round($(this).css('padding-right').replace('px', '') * ratio) + 'px';
                var newPadBottom = Math.round($(this).css('padding-bottom').replace('px', '') * ratio) + 'px';



                $(this).css('font-size', newFontSize);
                $(this).css('padding-left', newPadLeft);
                $(this).css('padding-top', newPadTop);
                $(this).css('padding-right', newPadRight);
                $(this).css('padding-bottom', newPadBottom);
            })
        }
    }



}



// WEBPACK FOOTER //
// ./scripts/routes/microsoft.js